<template>
  <div class="feature-section">
    <div class="text-h5 text-md-h4 mb-6 mb-md-12">
      Управляйте своей записью к врачу
    </div>
    <v-row>
      <v-col
        v-for="item in appointmentsFeatures"
        :key="item.title"
        cols="12"
        md="4"
      >
        <v-sheet
          class="d-flex flex-column h-100 justify-space-between bg-ui-kit-bg-secondary rounded-xl px-6 pt-8"
        >
          <div class="mb-4 text-h6 text-sm-landing-h5">
            {{ item.title }}
          </div>

          <LandingFeatureImage
            class="align-self-center"
            width="312"
            sm-width="312"
            height="288"
            sm-height="288"
            :src="`${item.image}.png`"
            :sm-src-set="`${item.image}.png 1x, ${item.image}_3x.png 3x`"
            :alt="item.alt"
          />
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
const appointmentsFeatures = [
  {
    title: 'Смотрите, когда приём, как подготовиться, как добраться',
    image: '/images/features/patient/appointment_detail',
    alt: 'Детали записи',
  },
  {
    title: 'Переносите и отменяйте записи без звонка в регистратуру',
    image: '/images/features/patient/appointment_cancel',
    alt: 'Отмена записи',
  },
  {
    title: 'Записывайтесь повторно на удобное время',
    image: '/images/features/patient/appointment_repeat',
    alt: 'Повторная запись',
  },
]
</script>
